// Packages
import { useSelector } from "react-redux";

const Footer = () => {
  const { legal_pages_urls, colors } = useSelector(
    (state) => state.checkoutStore,
  );
  return (
    <footer className="py-3 mt-4 me-n4 footer g-0 w-100 ps-3 pe-n4 text-lg-start text-center">
      {legal_pages_urls.refund && (
        <a
          href={legal_pages_urls.refund.link}
          className="d-sm-inline-block mx-2 underline-link"
          style={{ color: colors.text_color }}
        >
          {legal_pages_urls.refund.title}
        </a>
      )}
      {legal_pages_urls.terms && (
        <a
          href={legal_pages_urls.terms.link}
          className="d-sm-inline-block mx-2 underline-link"
          style={{ color: colors.text_color }}
        >
          {legal_pages_urls.terms.title}
        </a>
      )}
      {legal_pages_urls.privacy && (
        <a
          href={legal_pages_urls.privacy.link}
          className="d-sm-inline-block mx-2 underline-link"
          style={{ color: colors.text_color }}
        >
          {legal_pages_urls.privacy.title}
        </a>
      )}
    </footer>
  );
};
export default Footer;
